export default {
    crop: {
        title: "Oogst",
        cropSize: "Grootte van het gewas",
        zoom: "inzoomen",
        custom: 'Aangepast',
        post: 'Post',
        square: 'Vierkant',
        landscape: 'Landschap',
        story: 'Verhaal',
        portrait: 'Portret',
        carousel: 'Carrousel',
        commonAspectRatio: 'Gemeenschappelijk beeldverhouding',
    },
};
